import { MotionDirective as motion } from '@vueuse/motion';

export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.vueApp.directive('motion', motion());
});
